export default __webpack_public_path__ + "static/media/Bloodseer's Tasset.402897eb.jpg";